(function () {
  function isAppleEnv() {
    const ua = navigator.userAgent || '';
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|Edg|OPR|SamsungBrowser|Firefox/i.test(ua);
    const isInstagram = /Instagram/i.test(ua);
    return isIOS || isSafari || isInstagram;
  }

  function findAppleButton(root) {
    return (
      root.querySelector('[slot*="ApplePay"]') ||
      root.querySelector('[aria-label*="Apple Pay"]') ||
      root.querySelector('[title*="Apple Pay"]') ||
      root.querySelector('[class*="apple-pay"]') ||
      root.querySelector('[id*="apple-pay"]')
    );
  }

  function findShopButton(root) {
    return (
      root.querySelector('shopify-shop-pay-button') ||
      root.querySelector('shop-pay-wallet-button') ||
      root.querySelector('[aria-label*="Shop Pay"]') ||
      root.querySelector('[title*="Shop Pay"]') ||
      root.querySelector('[class*="shop-pay"]') ||
      root.querySelector('[id*="shop-pay"]')
    );
  }

  function mountWallets() {
    const root = document.querySelector('.cart__ctas');
    if (!root) return;

    const appleEnv = isAppleEnv();
    root.setAttribute('data-wallet-env', appleEnv ? 'apple' : 'shop');

    const paypalSlot = root.querySelector('.lb-wallet-slot--paypal');
    const appleSlot = root.querySelector('.lb-wallet-slot--apple');

    if (!paypalSlot || !appleSlot) return;

    const paypal = root.querySelector('shopify-paypal-button');
    if (paypal && !paypalSlot.querySelector('shopify-paypal-button')) {
      paypalSlot.appendChild(paypal);
      paypal.style.position = 'absolute';
      paypal.style.inset = '0';
      paypal.style.width = '100%';
      paypal.style.height = '100%';
      paypal.style.opacity = '0.01';
      paypal.style.zIndex = '3';
      paypal.style.display = 'block';
    }

    if (appleEnv) {
      const appleButton = findAppleButton(root);
      if (appleButton && !appleSlot.contains(appleButton)) {
        appleSlot.appendChild(appleButton);
        appleButton.style.position = 'absolute';
        appleButton.style.inset = '0';
        appleButton.style.width = '100%';
        appleButton.style.height = '100%';
        appleButton.style.opacity = '0.01';
        appleButton.style.zIndex = '3';
        appleButton.style.display = 'block';
      }

      root.querySelectorAll('shopify-shop-pay-button, shop-pay-wallet-button, shopify-google-pay-button, shopify-amazon-pay-button').forEach((el) => {
        el.style.display = 'none';
      });
    } else {
      const shopButton = findShopButton(root);
      if (shopButton && !appleSlot.contains(shopButton)) {
        appleSlot.appendChild(shopButton);
        shopButton.style.position = 'absolute';
        shopButton.style.inset = '0';
        shopButton.style.width = '100%';
        shopButton.style.height = '100%';
        shopButton.style.opacity = '0.01';
        shopButton.style.zIndex = '3';
        shopButton.style.display = 'block';
      }

      root.querySelectorAll('shopify-google-pay-button, shopify-amazon-pay-button').forEach((el) => {
        el.style.display = 'none';
      });
    }
  }

  function run() {
    setTimeout(mountWallets, 300);
    setTimeout(mountWallets, 900);
    setTimeout(mountWallets, 1600);
  }

  window.lbMountWallets = mountWallets;

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:add', run);
  document.addEventListener('cart:update', run);
})();